import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Grid, Button } from 'semantic-ui-react';

import { DateForm, Division, SearchInputBox } from 'components/Commons';

class DetailedSikdaeForm extends Component {
  render() {
    const { division, dateFormProps, showKeywordSearch = true } = this.props;
    const {
      formFn: { submitForm, handleEntSubmit }
    } = this.props;

    return (
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <DateForm {...dateFormProps} />
                {showKeywordSearch ? (
                  <SearchInputBox
                    handleSubmit={submitForm}
                    handleEntSubmit={handleEntSubmit}
                    styles={{ maxWidth: 190 }}
                    placeHolder="ID, 이름, 가맹점, 결제번호"
                  />
                ) : null}
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button color="black" inverted content="조회" style={{ width: '100%' }} onClick={submitForm} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Division division={division} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

DetailedSikdaeForm = connect((state) => ({
  division: state.commons.division
}))(DetailedSikdaeForm);

export default DetailedSikdaeForm;
